/**
 * Utilitário centralizado para obter a baseURL da API no app scheduling
 * Usa variável de ambiente NEXT_PUBLIC_API_URL ou fallback para desenvolvimento local
 */
export function getApiBaseURL(): string {
  return process.env.NEXT_PUBLIC_API_URL || 'http://api.sstlocal/scheduling';
}
